import React from 'react';
import moment from 'moment';
import {
  makePersistedTextFilter,
  makePersistedSelectFilter,
  onDatePickerFilter,
} from '../../../../../common/components/CommonTableDataFilter/CommonTableDataFilter';
import { LLLFormat } from '../../../../../common/services/ValidationRules';
import { whereOptions, whereValueLabelMap } from '../../../../ChargerDetails/components/ActivitiesTab';
import { EDGE_ACTIVITIES_COLUMNS as COLUMNS } from '../const/common';
import { TableSelect } from '../../../../ChargersList/components/ChargersTableComponents';
import { allMenuItem } from '../../../../../common/components/CommonTableColumns';
import { sortingLowerCase } from '../../../../../common/services/I2P2Helper';
import MenuItem from '../../../../../common/components/MenuItem/MenuItem';

const originSelectItems = [
  allMenuItem,
  ...whereOptions
    .sort((a, b) => sortingLowerCase(a.label, b.label))
    .map(({ value, label }) => (
      <MenuItem key={value} title={label} value={value}>
        {label}
      </MenuItem>
    )),
];

export const makeEdgeActivitiesColumns = ({ textFilter }) => [
  {
    ...COLUMNS.TIMESTAMP,
    minWidth: 180,
    Cell: ({ value }) => (value ? moment.utc(value).format(LLLFormat) : ''),
    Filter: onDatePickerFilter,
  },
  {
    ...COLUMNS.USER_NAME,
    minWidth: 200,
    Filter: textFilter,
  },
  {
    ...COLUMNS.ORIGIN,
    minWidth: 110,
    Cell: ({ value }) => whereValueLabelMap[value],
    Filter: ({ filter, onChange }) => <TableSelect options={originSelectItems} onChange={onChange} value={filter ? filter.value : ''} />,
  },
  {
    ...COLUMNS.FIELD,
    minWidth: 220,
    Filter: textFilter,
  },
  {
    ...COLUMNS.OLD_VALUE,
    minWidth: 180,
    Cell: ({ value }) => (value != null ? <span>{value}</span> : ''),
    Filter: textFilter,
  },
  {
    ...COLUMNS.NEW_VALUE,
    minWidth: 220,
    className: 'break-line-cell',
    Cell: ({ value }) => (value != null ? <span>{value}</span> : ''),
    Filter: textFilter,
  },
];

export const makeActivitiesFilters = () => {
  const TextFilter = makePersistedTextFilter(250);
  const WhereFilter = makePersistedSelectFilter([{ value: '', label: 'All' }, ...whereOptions]);

  return makeEdgeActivitiesColumns({ textFilter: TextFilter, whereFilter: WhereFilter });
};

export const edgeActivitiesDefaultSorting = { id: 'timestamp', desc: true };
